<template>
  <div v-if="vehicleData" class="main-container-shipmentinfo">
    <div class="inner-container" id="printable-content">
        <div class="confirm-container-main">
                <div class="close-shipment-info-container">
                    <svg class="close-shipment-info" @click="closeAddressInfo()" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                        <path d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z" fill="#32ccfe" class="fill-000000"></path>
                        <path d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z" fill="#32ccfe" class="fill-000000"></path>
                    </svg>
                </div>
                
                <div class="confirm-header-container">
                    <h1 class="package-details-header">Vehicle Details</h1>
                    <img src="../../../assets/LREXDinoFooter.jpg" alt="">
                </div>

                <div class="inner-overflow-container" id="inner-overflow-container">
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                                            <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                                <g>
                                                <g>
                                                    <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                                    <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                                    <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                                    <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                                    <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                                    <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                                    <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                                </g>
                                                <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                                <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                                <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                                </g>
                                            </g>
                                        </svg>
                                        <h2>Vehicle</h2>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <label for="VehicleCode">Vehicle Code</label>
                                        <p name="VehicleCode">{{vehicleData.vehicleCode}}</p>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <label for="PlateNumber">Plate Number</label>
                                        <p name="PlateNumber">{{vehicleData.plateNumber}}</p>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <label for="VehicleID">Vehicle ID</label>
                                        <p name="VehicleID">{{vehicleData.vehicleID}}</p>
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <label for="isActiveTag">Active</label>
                                        <p name="isActiveTag">{{vehicleData.isActive}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="inner-overflow-container" id="inner-overflow-container">
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1 update-location">
                                    <div class="confirm-svg">
                                        <svg version="1.1" id="Layer_2_00000017498551833638599530000000546862870078238139_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 244 164" xml:space="preserve" data-v-24f3d49d=""><g id="_Ñëîé_1" data-v-24f3d49d=""><g data-v-24f3d49d=""><g data-v-24f3d49d=""><path class="st0" d="M4,110v16c0,5.5,4.5,10,10,10h30" data-v-24f3d49d=""></path><path class="st0" d="M92,136h50c5.5,0,10-4.5,10-10V14c0-5.5-4.5-10-10-10H23" data-v-24f3d49d=""></path><path class="st0" d="M27,4H14C8.5,4,4,8.5,4,14v100" data-v-24f3d49d=""></path><circle class="st0" cx="68" cy="136" r="24" data-v-24f3d49d=""></circle><circle class="st0" cx="196" cy="136" r="24" data-v-24f3d49d=""></circle><line class="st0" x1="128" y1="136" x2="172" y2="136" data-v-24f3d49d=""></line><path class="st0" d="M220,136h10c5.5,0,10-4.5,10-10V87.9c0-2.5-0.9-4.9-2.6-6.8L199,39.2c-1.9-2.1-4.6-3.2-7.4-3.2H152" data-v-24f3d49d=""></path><path class="st0" d="M240,84h-50c-5.5,0-10-4.5-10-10V48" data-v-24f3d49d=""></path></g></g></g><image width="507" height="492" xlink:href="data:image/png;base64,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" transform="matrix(9.068223e-02 0 0 9.068223e-02 10.352 11.3701)" data-v-24f3d49d="" style="overflow: visible;"></image></svg>
                                        <h2>Update Vehicle</h2>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <input placeholder="Vehicle Code" disabled v-model="vehicleData.vehicleCode" type="text">
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <input placeholder="Plate Number" v-model="vehicleData.plateNumber" type="text">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input placeholder="Vehicle ID" v-model="vehicleData.vehicleID" type="text">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <label style="margin-top: 5px;" for="isActive">Active</label>
                                        <input placeholder="Active" id="isActive" value="true" v-model="isActive" type="checkbox" :checked="vehicleData.isActive">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <loading-charts v-if="loadingData"/>
                    <button class="print-button" @click="updateVehicleData()">Update Vehicle</button>
            </div>
    </div>
  </div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue';
import { updateVehicle } from '../../../graphql/mutations';

export default {
    props:['dropBoxCode', 'jwtToken'],
    components:{
        AlertUser,
        LoadingCharts
    },
    data(){
        return{
            vehicleData: null,
            isActive: undefined,
            toggleAlertBox: false, 
            alertMessage: null,
            loadingData: false,
        }
    },
    methods:{
        async getVehicleDataForTable(){
            this.loadingTable = true;
            let graphqlQuery = `query getVehicle{
                getVehicle(vehicleCode: "${this.dropBoxCode}"){
                    vehicleCode
                    isActive
                    plateNumber
                    vehicleID
                }
            }`
            
            try{
                let getVehicle = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.vehicleData = getVehicle.data.getVehicle;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting vehicle"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async updateVehicleData(){
            this.loadingTable = true;
            try{
                let updateVehicleData = await API.graphql({
                query:  updateVehicle,
                variables:{
                    input:{
                        vehicleCode: this.vehicleData.vehicleCode,
                        vehicleID: this.vehicleData.vehicleID,
                        plateNumber: this.vehicleData.plateNumber,
                        isActive: this.isActive
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Vehicle updated"
                console.log(updateVehicleData)
                await this.getVehicleDataForTable();
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error updating vehicle"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        closeAddressInfo(){
            this.$emit('closeAddressInfo', false)
        }
    },
    mounted(){
        this.getVehicleDataForTable();

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
</script>

<style scoped>
/* SVG Styles */

    .st0{
        fill: none;
        stroke: #000000;
        stroke-width: 8;
        stroke-miterlimit: 10;
    }

    .st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}


    .cls-1-alt{
        fill: none;
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 8px;
    }

    .cls-1 {
        fill: none;
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 8px;
    }

    .cls-2 {
        fill: none;
        stroke: #000;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 12px;
    }

    .cls-2-alt{
        stroke: #000;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 11px;
    }

    input, select{
        padding: 10px;
        font-size: 15px;
        border: 1px solid rgba(0,0,0,.336);
        border-radius: 15px;
        outline: none;
        margin-top: 5px;
    }


input[type=file]::file-selector-button {
    border: none;
    padding: 5px;
    border-radius: 15px;
    background-color: #32ccfe;
    transition: 1s;
    color: #fff;
    cursor: pointer;
}

input[type=file]::file-selector-button:hover {
    background-color: #2dbbeb;
    transition: 1s;
}

.main-container-shipmentinfo{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0;
    padding: 0;
    z-index: 10;
}

@keyframes shipment-details-animate {
    from{
        margin-top: -2%;
    }
    to{
        margin-top: 2.5%;
    }
}

.inner-container{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    flex-direction: column;
}

.confirm-container-main{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    max-height: 90vh;
    overflow-x: auto;
    animation: shipment-details-animate 1s ease;
    margin-top: 2.5%;
    box-shadow: rgba(0, 0, 0, 0.164) 0px 1px 10px;
    background-color: #fff;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.confirm-header-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 15px 0 15px;
    justify-content: space-between;
}

.confirm-header-container img{
    width: 40px;
    margin-right: 15px;
}

.confirmLabelContainer img{
    width: 50%;
    max-width: 150px;
    margin-top: 5px;
    border-radius: 5px;
}

.file-input{
    width: 80%;
}

.weight-container{
    background-color: #fff;
    margin: 0px 5% 2% 5%;
    padding: 10px;
    border-radius: 25px;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
}

.weight-container label{
    margin-right: 5px;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    text-align: left;
    padding: 10px;
}

.inner-overflow-container{
    max-height: 90%;
    overflow-y: auto;
    margin-bottom: 10px;
    margin: 5px;
    border-top: 1px #d5d5d5 solid;
    border-bottom: 1px #d5d5d5 solid;
}

.confirmContainerInner1{
    background-color: #f5f5f5;
    margin: 5px;
    padding: 10px;
    border-radius: 25px;
    flex-basis: 25%;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
}

.update-location{
    flex-basis: 100%;
}

.confirmContainerInner1 h2{
    margin: 0;
    text-align: left;
    white-space: nowrap;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.confirm-container-address{
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
}

.package-details-header{
    background-color: #32ccfe;
    color: #fff;
    padding: 10px;
    border-radius: 50px;
    width: fit-content;
    margin: 0;
}

.confirmContainer{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.confirmContainerInner label{
    background-color: transparent;
    border: none;
    padding: 0px;
    margin-right: 10px;
    font-weight: bold;
    white-space: nowrap;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    padding: 0 !important;
    margin-top: 5px;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.confirmLabelContainer{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
}

.confirmLabelContainer p{
    margin-top: 5px;
    margin-bottom: 5px;
}

.confirmLabelContainer2{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-bottom: 5px;
}

.auto-complete-container{
    margin-top: 5px;
}

.service-container{
    display: flex;
    margin: 5px;
    flex-direction: column;
}

.close-shipment-info{
    width: 30px;
    height: 30px;
    margin-right: 5%;
    margin-top: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.close-shipment-info:hover{
    transition-duration: .5s;
    border-radius: 999px;
    background-color: #e4e4e4;
}

.print-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-left: 25px;
    /* margin-top: 5px; */
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.print-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.create-button{
    background-color: #33f18a;
    margin-left: 20px;
}

.create-button:hover{
    transition-duration: .5s;
    background-color: #31d77b;
}

.close-shipment-info-container{
    display: flex;
    justify-content: flex-end;
}

@media only screen and (max-width: 820px){
    .confirm-container-main{
        width: 90%;
    }

    .weight-container{
        background-color: #fff;
        margin: 5px 15px;
        width: fit-content;
    }

    .confirmContainerInner{
        flex-direction: column;
        flex-wrap: wrap;
    }

    .confirmContainerInner1{
        width: fit-content;
    }

    .package-details-header{
        font-size: 1.6em;
    }
}

@media only screen and (max-width: 530px){
    .service-data{
        flex-direction: column;
    }
}
</style>